exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".JF1dSR42teRlzj24028mz_0{width:100%;height:100%;display:block;position:absolute;top:0;left:0}", "", {"version":3,"sources":["C:/Users/GENBU/swipevideo/src/components/PlayerFrame.vue"],"names":[],"mappings":"AACA,yBACE,WAAY,AACZ,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACT","file":"PlayerFrame.vue","sourcesContent":["\n.iframe {\n  width: 100%;\n  height: 100%;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"iframe": "JF1dSR42teRlzj24028mz_0"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bc7966a4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PlayerFrame.vue
// module id = 135
// module chunks = 0 1